import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import InventoryLogReportsFilter from '../components/InventoryLogReportsFilter';
import InventoryLogReport from '../components/InventoryLogReport';
import ReportHeaderLocation from '../components/ReportHeaderLocation';
import NoAccess from '../noAccess';
import {hasReportsAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/editor/insert-chart';

export const fuseInventoryLogReportsIcon = Icon;

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
    reportHeader: {
        margin: '0 0 5px 0',
    },
    reportNote: {fontStyle: 'italic'},
};

/**
 * Inventory Log class for retrieving and displaying table summary
 *
 */
export class InventoryLogReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            abort: false,
            errorMessage: null,
            location: {
                dbaPriceLevel: null,
                id: null,
                name: null,
                priceLevel: null,
                productType: null
            },
            message: null,
            reportNote: '',
            selectedZeroDay: null,
            summaryComplete: false,
            system: '',
        };
    }

    /**
     * Handle event props from Filter
     *
     * @param type
     * @param value
     */
    handleFilterSelect = (type, value) => {
        // Store values for selected Location object and its attributes
        if (type === 'location') {
            // Gather Price Level and Product Type data from Location and DBA
            let locationDBAPriceLevel = null;
            let locationPriceLevel = null;
            let locationProductType = null;
            const dba = value.dba;
            if (dba) {
                const dbaPriceLevel = dba.price_level;
                if (dbaPriceLevel && dbaPriceLevel.name) {
                    locationDBAPriceLevel = dbaPriceLevel.name;
                }
                const dbaProductType = dba.product_type;
                if (dbaProductType) {
                    locationProductType = dbaProductType;
                }
            }
            const priceLevel = value.price_level;
            if (priceLevel && priceLevel.name) {
                locationPriceLevel = priceLevel.name;
            }
            // Store the entire Location with calculated values
            const location = value;
            location.dbaPriceLevel = locationDBAPriceLevel;
            location.priceLevel = locationPriceLevel;
            location.productType = locationProductType;

            const system = localStorage.getItem('system');

            // Set Location for table component
            this.setState({
                abort: false,
                errorMessage: null,
                summaryComplete: false,
                location: location,
                selectedZeroDay: null,
                system: system
            });
        }

        // Set Zero Day selection for table component
        if (type === 'zero_day') {
            this.setState({
                abort: false,
                errorMessage: null,
                summaryComplete: false,
                selectedZeroDay: value
            });
        }
    };

    /**
     * Handle event props for Summary table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete
        });
    };

    /**
     * Handle event props for Summary messaging
     *
     * @param message
     */
    handleMessage = (message) => {
        this.setState({
            message: message
        });
    };

    render() {

        const {
            abort,
            errorMessage,
            location,
            message,
            selectedZeroDay,
            summaryComplete,
            system
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Inventory Log Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>An Inventory Log Report displays the latest inventory status for a specific Location.</p>
                </span>
            );
        };

        return (
            <div className="lists-container" ref={e => (this.printReportRef = e)}>
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Inventory Log Report Filter (Location and Zero Day) */}
                        <InventoryLogReportsFilter
                            onSelectLocation={this.handleFilterSelect}
                            onSelectZeroDay={this.handleFilterSelect}
                        />

                        {/* Print Header */}
                        {location && selectedZeroDay &&
                        <ReportHeaderLocation
                            location={location}
                            zeroDay={selectedZeroDay}
                            reportType="Inventory Log Report"
                        />
                        }

                        {/* Inventory Log Report Content */}
                        {location && location.id && selectedZeroDay && !abort &&
                        <div>

                            {/* Inventory Log Report Header, Loader, and messaging */}
                            <div className="list-header hide-print report-header" style={styles.reportHeader}>
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={styles.button}
                                            />
                                        }
                                        content={() => this.printReportRef}
                                    />
                                </div>
                                <h2 className="report-header-title">Inventory Log Report</h2>
                                <p>
                                    <span className="bold">Store: </span>
                                    {location.id} - {location.name} - {location.city}, {location.state}
                                    <br/>
                                    <span className="bold">Zero Day: </span>{selectedZeroDay}
                                    <br/>
                                    <span className="bold">Product Type: </span>{location.productType}
                                </p>
                                {message &&
                                <p style={styles.reportNote}>
                                    {message}
                                </p>
                                }
                            </div>

                            {!summaryComplete &&
                            <div className="loader-container">
                                <h4>Generating Report...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                            }

                            {/* Summary */}
                            <InventoryLogReport
                                location={location}
                                onSummaryComplete={this.handleSummaryComplete}
                                onDisplayMessage={this.handleMessage}
                                system={system}
                                zeroDay={selectedZeroDay}
                            />
                        </div>
                        }

                        {/* Error and Messaging */}
                        {abort && errorMessage &&
                            <div className="error">
                                <p>{errorMessage}</p>
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/InventoryLogReports.js